import $fn from '@/utils/fn';
import {
	getUserInfo,
	getMenu,
} from '@/req/user'
export default {
	namespaced: true,
	state: {
		// 用户信息
        info: {},
        isRouterAlive: false,
        searchUrl: {},
		// 菜单列表
		menu: [],
		weix: '',
		isInvoiceAssistant: false
	},
	// getters:{},
	mutations: {
		setInfo(state: { info: any; }, obj: any) {
			state.info = obj
		},
		setRouter(state: { isRouterAlive: any; }, isRouterAlive: any) {
			state.isRouterAlive = isRouterAlive
		},
		setInvoiceA(state: { isInvoiceAssistant: any; }, isInvoiceAssistant: any) {
			state.isInvoiceAssistant = isInvoiceAssistant
		},
		setSearchUrl(state: { searchUrl: any; }, searchUrl: any) {
			state.searchUrl = searchUrl
		},
		setMenu(state: { menu: any; }, obj: any) {
			state.menu = obj
		},
		weixe(state: { weix: any; }, obj: any) {
			state.weix = obj
		},
	},
	actions: {
		async authInfo({
            commit,
        // tslint:disable-next-line:align
        }, info) {
            commit('setInfo', info)
        },
		async authRouter({
            commit,
        // tslint:disable-next-line:align
        }, routeState) {
            commit('setRouter', routeState)
        },
		async authInvoiceA({
			 commit,
				// tslint:disable-next-line:align
			 }, routeState) {
			commit('setInvoiceA', routeState)
		},
		//
		async wx({
			 commit,
			 // tslint:disable-next-line:align
		 }, routeState) {
			commit('weixe', routeState)
		},
		async authSearchUrl({
            commit,
        // tslint:disable-next-line:align
        }, searchUrl) {
            commit('setSearchUrl', searchUrl)
        },
		async updateMenu({
			commit,
		}) {
			const res = await getMenu()
			if ($fn.n(res.code) !== 200) {
				window.App.$Message.error(res.msg)
			} else {
				commit('setMenu', res.data)
			}

		},
		// 设置当前用户角色
		async updateInfo({
			commit,
		}) {
			try {
				const res = await getUserInfo()
				if ($fn.n(res.code) === 200) {
					commit('setInfo', res.data)
				} else {
					if (window.location.href.indexOf('/login') === -1) {
						window.App.$router.push({
							path: '/login',
						})
					}
				}
			} catch (err) {
				if (window.location.href.indexOf('/login') === -1) {
					window.App.$router.push({
						path: '/login',
					})
				}
			}
		},
	},
}
